export default function PageNotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-green-100 to-green-300 text-center px-6">
      {/* Cricket Icon */}
      {/* <div className="mb-6">
        <img
          src="/cricket-ball.png" // replace with your cricket ball/bat image
          alt="Cricket Ball"
          className="w-28 h-28 animate-bounce"
        />
      </div> */}

      {/* 404 Text */}
      <h1 className="text-7xl font-extrabold text-green-800">404</h1>
      <h2 className="text-2xl font-semibold text-green-700 mt-4">
        Oops! Page Not Found
      </h2>

      <p className="mt-2 text-green-600 max-w-lg">
        Looks like you’ve been bowled out! The page you’re looking for doesn’t
        exist on our Cricket Registration site.
      </p>

      {/* Buttons */}
      <div className="mt-6 flex gap-4">
        <a
          href="/"
          className="px-6 py-3 bg-green-700 text-white rounded-xl shadow hover:bg-green-800 transition"
        >
          Back to Home
        </a>
       
      </div>
    </div>
  );
}
